import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import type { IUser } from '../../../assets/types/dtoTypes';
import { sasNeedsRefresh } from '../utils/url-sas.util';
import {ImageService} from "./image.service";

@Injectable({ providedIn: 'root' })
export class CandidatePrepService {
  constructor(private readonly imageService: ImageService) {}

  async prepare(user: IUser): Promise<IUser> {
    const updated = { ...user };

    if (updated.profileImageUrl && !updated.profileImageUrl.includes('?sv=')) {
      updated.profileImageUrl = await firstValueFrom(
        this.imageService.appendSasTokenToProfileImageUrl(updated.profileImageUrl, updated.id, true),
      );
    }

    if (updated.materials?.length) {
      updated.materials = await Promise.all(
        updated.materials.map(async m => {
          if (sasNeedsRefresh(m.url)) {
            const freshUrl = await firstValueFrom(
              this.imageService.appendSasTokenToProfileImageUrl(m.url, updated.id, true),
            );
            return { ...m, url: freshUrl };
          }
          return m;
        }),
      );
    }

    return updated;
  }
}
